import axios from "axios";
import { EventEmitter } from "events";
import { ConfiguratorModel } from "./ConfiguratorModel";
import { HotspotController } from "./HotspotController";
import { DefaultSequenceInterpreter } from "./Sequence/DefaultSequenceInterpreter";
import { SequencePlayer } from "./Sequence/SequencePlayer"

export class SequenceController {
  public get event():EventEmitter { return this._event; }
  public get running():boolean { return this._player.running; }

  public static EVENT_START:string = "start";
  public static EVENT_STOP:string = "stop";

  private _event = new EventEmitter();
  private _player:SequencePlayer;

  public constructor(
    private model:ConfiguratorModel,
    private hotspotController:HotspotController,
    private setTextHandler:(text:string, timeout:number, fade:boolean, position:string)=>void
  ) {
    this._player = new SequencePlayer(new DefaultSequenceInterpreter(this.model, this.hotspotController, this.setTextHandler));
  }

  public async playHighlightFly():Promise<void> {
    // TODO: stop player if it already is running.

    this.event.emit(SequenceController.EVENT_START);

    await this._player.play((await axios.get(`${HASH}/sequences/highlightFly.json`)).data);

    this.event.emit(SequenceController.EVENT_STOP);
  }

  public stop():void {
    this._player.stop();
  }
}